module.exports = __webpack_public_path__ + "static/media/1t.1c00d968.png";